import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiProvider } from '../providers/api.provider';
import { HttpErrorResponse } from '@angular/common/http';
import { Photo } from '../models/photo';
import { environment } from '../../../environments/environment';
import { first } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PhotoService {
  private currentPhotosSubject: BehaviorSubject<number[]>;
  public currentPhotos: Observable<number[]>;
  private _baseUrl: string = environment.apiUrl;

  /*
   * Build the api url call with the provided method name
   */
  private getApiUrlCall(methodName: string): string {
    let url = '';

    url = this._baseUrl + methodName;

    return url;
  }

  constructor(private apiProvider: ApiProvider) {
    this.currentPhotosSubject = new BehaviorSubject<number[]>(null);
  }

  public get photosValue(): number[] {
    return this.currentPhotosSubject.value;
  }

  async getPhotos(waybill: number) {
    this.apiProvider.GetPhotos(waybill).subscribe(
      (photos: number[]) => {
        this.currentPhotosSubject = new BehaviorSubject<number[]>(photos);
        this.currentPhotos = this.currentPhotosSubject.asObservable();
      },
      (err: HttpErrorResponse) => {
        this.currentPhotosSubject.next(null);
      }
    );
  }

  getPhoto(photoID: number): any {
    return `${this.getApiUrlCall('api/v3/Mobiles/GetPhoto')}?photoID=${photoID}`;
  }

  clearPhotos() {
    this.currentPhotosSubject.next(null);
  }
}
